// src/components/ApiKeyModal.tsx
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { EventBus } from 'src/common/EventBus';
import { useNotificationMessage } from 'src/common/notification/message.hook';

import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { ApiKey } from '../../utils/apiKeyService';
import { ClipboardCopyIcon } from '@heroicons/react/outline';

interface ApiKeyModalProps {
  apiKey: ApiKey;
  onClose: () => void;
}

const ApiKeyModal: React.FC<ApiKeyModalProps> = ({ apiKey, onClose }) => {
    
    const { setSuccessNotification } = useNotificationMessage();

    const onCopyKey = () => {
        setSuccessNotification('Api Key copied to clipboard');
    }

    const onCopySecret = () => {
        setSuccessNotification('Api Secret copied to clipboard');
    }
  
    return (
    <Transition appear show as={Fragment}>
      <Dialog as="div" className="fixed inset-0 overflow-y-auto" style={{zIndex:999}} onClose={()=>{}}>
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          </Transition.Child>

          <span className="inline-block h-screen align-middle" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-2xl p-6 my-8 overflow-y-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
              <Dialog.Title as="h3" className="text-lg font-medium text-gray-900">
                New API Key Created
              </Dialog.Title>
              <div className="mt-4">

              <p className='text-bedrock-p pb-4'>Please copy and save the API key & API secret somewhere safe. The secrets are visible only this time and cannot be retrieved. You'll have to regenerate a new one again.</p>


                <div className='mt-3 flex'>
                <p>
                    API Key: 
                </p>                    
                    <CopyToClipboard
                      text={apiKey.api_key}
                      onCopy={onCopyKey}
                    >
                    <div className='flex space-x-2 cursor-pointer'>
                    <div>{apiKey.api_key}</div><ClipboardCopyIcon className='w-5 h-5'/>
                    </div>
                    </CopyToClipboard>
                </div>

                <div className='flex space-x-2 mt-4  pb-4'>
                <p className="">
                    API Secret: 
                </p>
                    <CopyToClipboard
                      text={apiKey.api_secret || ''}
                      onCopy={onCopySecret}
                    >
                    <div className='flex space-x-2 cursor-pointer'>
                    <div>{apiKey.api_secret}</div><ClipboardCopyIcon className='w-5 h-5'/>
                    </div>
                    </CopyToClipboard>
                </div>
              </div>
              <div className="mt-8">
                <button
                  onClick={onClose}
                  className="relative block items-center max-w-max mt-4 mx-auto space-x-1 cursor-pointer text-white bg-gray-700 hover:bg-gray-600 focus:outline-none py-2 px-4 border border-transparent text-sm font-semibold rounded-md transition duration-150 ease-in-out"
                >
                  Close
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ApiKeyModal;
